<script>

import useValidation from "@/use/Validation";
import {ref} from "vue";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import {usePaySlipStore} from "@/stores/PaySlip";
import axios from "axios";

export default {
    props: {
        filter: Object,
        workers: Array,
        annexId: Number,
    },
    setup(props) {
        const {mxRules} = useValidation();
        const {$refs} = useTools();
        const {getBack} = useSharedMethod();
        const loading = ref(false);
        const reasonIds = ref(null);
        const updateOption = ref('KEEP');
        const paySlipStore = usePaySlipStore();
        
        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                const ids = props.workers.map((w) => w.id);
                const body = {
                    ids: ids,
                    annexId: props.annexId,
                    reasonIds: reasonIds.value,
                    updateOption: updateOption.value,
                };
                axios.put(`/payments/addAbsenceRequestPaySections`, body, {
                    params: props.filter,
                }).then(response => {
                    paySlipStore.updateAll(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        const loadingExportExcel = ref(false);
        
        function exportExcel() {
            if ($refs.form.validate()) {
                loadingExportExcel.value = true;
                const ids = props.workers.map((w) => w.id);
                const body = {
                    ids: ids,
                    annexId: props.annexId,
                    reasonIds: reasonIds.value,
                };
                axios.put(`/paySectionImport/exportAbsenceRequestImport`, body, {
                    responseType: 'blob',
                    params: props.filter,
                }).then(response => {
                    // Create a new Blob object using the response data of the file
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'demandes.xlsx'); // Set the file name for download
                    document.body.appendChild(fileLink);
                    
                    fileLink.click(); // Programmatically trigger the download
                    
                    // Clean up by revoking the Object URL and removing the link element
                    window.URL.revokeObjectURL(fileURL);
                    fileLink.remove();
                }).finally(() => {
                    loadingExportExcel.value = false;
                });
            }
        }
        
        return {
            mxRules,
            loading,
            reasonIds,
            loadingExportExcel,
            updateOption,
            exportExcel,
            save
        }
    }
};
</script>

<template>
    <v-form ref="form" lazy-validation>
        <v-row dense>
            <v-col cols="12">
                <strong>{{ $t('module.absence_reason') }} *</strong>
                <str-absence-reason-autocomplete
                    v-model="reasonIds"
                    multiple
                    :rules="[mxRules.listRequired]"
                />
            </v-col>
            <v-col cols="12">
                <v-radio-group v-model="updateOption" column>
                    <v-radio value="KEEP" :label="$t('common.keep')" color="blue"/>
                    <v-radio value="ERASE" :label="$t('common.replace')" color="red"/>
                    <v-radio value="SUM" :label="$t('common.accumulate')" color="teal"/>
                </v-radio-group>
            </v-col>
            <v-col cols="6">
                <w-btn-export
                    block
                    :loading="loadingExportExcel"
                    @press="exportExcel"
                />
            </v-col>
            <v-col cols="6">
                <w-btn-import
                    block
                    :loading="loading"
                    @press="save"
                />
            </v-col>
        </v-row>
    </v-form>
</template>